import { render, staticRenderFns } from "./BuddhaBoard.vue?vue&type=template&id=02e0a63d&scoped=true"
import script from "./BuddhaBoard.vue?vue&type=script&lang=js"
export * from "./BuddhaBoard.vue?vue&type=script&lang=js"
import style0 from "./BuddhaBoard.vue?vue&type=style&index=0&id=02e0a63d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e0a63d",
  null
  
)

export default component.exports